module.exports = __webpack_public_path__ + "img/dummy-1.80ccd2da.png";